import { useEffect } from 'react'
import { installDevStackMock } from './mockFetch'

// Installs the stack-permutation fetch mock for the lifetime of the Live
// Updates scene, and renders nothing.
//
// This is deliberately separate from DevStackToolbar, which renders the UI.
// The toolbar sits after the scene's loading guards, so it only mounts once
// `live_updates/configurations` has already been fetched and cached — by then
// patching `window.fetch` is too late and the picker lists the merchant's real
// configurations instead of the presets, with no way to reach them. Mounted as
// a sibling ABOVE the scene, this component's effect runs before the scene's
// own RTK Query subscription fires, so the very first fetch is the mocked one.
const DevStackMock = () => {
  useEffect(() => installDevStackMock(), [])
  return null
}

export default DevStackMock
